import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Auth from './pages/Auth';
import AuthCallback from './pages/AuthCallback';
import Onboarding from './pages/Onboarding';
import WeddingSite from './pages/WeddingSite';
import Rsvp from './pages/Rsvp';
import AddressForm from './pages/AddressForm';
import GiftPage from './pages/GiftPage';
import SeatFinder from './pages/SeatFinder';
import PartnerInvite from './pages/PartnerInvite';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import InstallPrompt from './components/InstallPrompt';
import CheckoutSuccess from './pages/CheckoutSuccess';
import OurStory from './pages/OurStory';
import RealWeddings from './pages/RealWeddings';
import Partners from './pages/Partners';
import Contact from './pages/Contact';
import LegalPage from './pages/LegalPage';
import Admin from './pages/Admin';
import PrivacyRequest from './pages/PrivacyRequest';
import CookieBanner from './components/CookieBanner';
import { Toaster } from './components/ui/toaster';
import { Heart } from 'lucide-react';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#FBF7F2] flex flex-col items-center justify-center">
        <div className="w-10 h-10 rounded-full bg-[#7B2C3B] flex items-center justify-center mb-3 animate-pulse-soft">
          <Heart className="w-5 h-5 text-[#FBF7F2] fill-[#FBF7F2]" />
        </div>
        <p className="text-sm text-[#6A6A6A]">Loading your day…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth?next=/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/wedding/:slug" element={<WeddingSite />} />
            <Route path="/rsvp/:token" element={<Rsvp />} />
            <Route path="/address/:token" element={<AddressForm />} />
            <Route path="/gifts/:slug" element={<GiftPage />} />
            <Route path="/seat/:slug" element={<SeatFinder />} />
            <Route path="/partner-invite/:token" element={<PartnerInvite />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:slug" element={<ArticleDetail />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/checkout/success" element={<ProtectedRoute><CheckoutSuccess /></ProtectedRoute>} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/real-weddings" element={<RealWeddings />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-request" element={<PrivacyRequest />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
            <Route path="/:slug" element={<LegalPage />} />
          </Routes>
          <Toaster />
          <InstallPrompt />
          <CookieBanner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
